// @flow
import * as React from "react";
import { Form } from "react-final-form";
import { type FormApi } from "final-form";
import cx from "classnames";

import FormContext from "../../utils/form-context";
import Card from "../Card";
import SvgButton from "../SvgButton";
import EditIcon from "../../assets/icons/other/edit.svg";
import SaveIcon from "../../assets/icons/other/save.svg";

import styles from "./EditableForm.scss";
import { isFormSubmitting } from "../../utils/helpers";
import Preloader from "../Preloader";

type EditableFormState = {
  isEditMode: boolean
};

type EditableFormProps = {
  children: React.Node,
  initialValues: Object,
  onSubmit: (values: {}, form: FormApi) => void,
  isLocked: boolean
};
class EditableForm extends React.Component<EditableFormProps, EditableFormState> {
  state = {
    isEditMode: false
  };

  static defaultProps = {
    onSubmit: null,
    isLocked: false
  };

  formApi = null;

  toggleMode = (isEditMode: boolean) => {
    this.setState({ isEditMode });
  };

  handleSubmit = (values: any, form: FormApi) => {
    const { onSubmit } = this.props;
    return Promise.resolve(onSubmit(values, form)).then(() => this.toggleMode(false));
  };

  render() {
    const { children, initialValues, isLocked } = this.props;
    const { isEditMode } = this.state;

    return (
      <FormContext.Provider
        value={{
          toggleMode: this.toggleMode,
          isEditMode
        }}
      >
        <Form
          onSubmit={this.handleSubmit}
          initialValues={initialValues}
          render={({ form }) => (
            <form>
              <Card
                action={() =>
                  !isLocked &&
                  (isFormSubmitting(form) ? (
                    <div className={cx(styles.editButton)}>
                      <Preloader customStyles={styles.preloader} />
                    </div>
                  ) : (
                    <SvgButton
                      className={styles.editButton}
                      src={isEditMode ? SaveIcon : EditIcon}
                      alt="editieren"
                      label={isEditMode ? "Speichern" : "Bearbeiten"}
                      onClick={isEditMode ? form.submit : () => this.toggleMode(true)}
                      data-testid="editButton"
                    />
                  ))
                }
              >
                {children}
              </Card>
            </form>
          )}
        />
      </FormContext.Provider>
    );
  }
}

export default EditableForm;
